import { useState, useEffect } from 'react';
import styles from './ProdutoModal.module.css';
import { listar, COLECOES } from '../../../services/firestore';

export default function ProdutoModal({ produto, onSalvar, onCancelar, salvando }) {
  const editando = !!produto;

  const [cor, setCor] = useState(produto?.cor || '');
  const [resina, setResina] = useState(produto?.resina || '');
  const [valorPorLitro, setValorPorLitro] = useState(
    produto?.valorPorLitro != null ? String(produto.valorPorLitro) : ''
  );
  const [orientacao, setOrientacao] = useState(produto?.orientacao || '');
  const [ativo, setAtivo] = useState(produto?.ativo ?? true);

  const [opcoes, setOpcoes] = useState({ resinas: [] });
  const [carregandoOpcoes, setCarregandoOpcoes] = useState(true);
  const [erroOpcoes, setErroOpcoes] = useState('');

  useEffect(() => {
    let ativoEfeito = true;
    (async () => {
      setCarregandoOpcoes(true);
      setErroOpcoes('');
      try {
        const resinas = await listar(COLECOES.RESINAS, { ordenarPor: 'nome' });
        if (!ativoEfeito) return;
        setOpcoes({ resinas: resinas.filter((r) => r.ativo).map((r) => r.nome) });
      } catch (e) {
        if (!ativoEfeito) return;
        setErroOpcoes(e.message || 'Erro ao carregar resinas. Verifique a conexão.');
      } finally {
        if (ativoEfeito) setCarregandoOpcoes(false);
      }
    })();
    return () => {
      ativoEfeito = false;
    };
  }, []);

  function comValorAtual(lista, valorAtual) {
    if (valorAtual && !lista.includes(valorAtual)) {
      return [valorAtual, ...lista];
    }
    return lista;
  }

  const valido = cor.trim().length > 0 && resina.length > 0;

  function handleSalvar() {
    if (!valido) {
      alert('Preencha todos os campos obrigatórios (marcados com *).');
      return;
    }
    const vpl = parseFloat(valorPorLitro.replace(',', '.'));
    onSalvar({
      cor: cor.trim(),
      resina,
      valorPorLitro: isNaN(vpl) ? null : vpl,
      orientacao: orientacao.trim(),
      ativo,
    });
  }

  const resinasOpts = comValorAtual(opcoes.resinas, resina);

  return (
    <div className={`${styles.modalOverlay} ${styles.aberto}`}>
      <div className={styles.modal}>
        <div className={styles.modalHead}>
          <div>
            <div className={styles.modalTitle}>
              {editando ? 'Editar produto' : 'Novo produto'}
            </div>
            <div className={styles.modalSubtitle}>
              Preencha os dados do produto. Campos com * são obrigatórios.
            </div>
          </div>
          <button className={styles.modalClose} onClick={onCancelar}>
            ✕
          </button>
        </div>

        <div className={styles.modalBody}>
          {erroOpcoes && (
            <div
              style={{
                background: '#fdecea',
                color: '#b51013',
                border: '1px solid #f5c6cb',
                borderRadius: 8,
                padding: '10px 14px',
                marginBottom: 14,
                fontSize: 14,
              }}
            >
              {erroOpcoes}
            </div>
          )}

          <div className={styles.formSection}>
            <div className={styles.formSectionTitle}>Identificação</div>
            <div className={styles.formGrid}>
              <div className={styles.formField}>
                <label htmlFor="prod-cor" className={styles.formLabel}>
                  Cor <span className={styles.obrigatorio}>*</span>
                </label>
                <input
                  id="prod-cor"
                  className={styles.formInput}
                  placeholder="Ex: CINZA (N 6,5)"
                  value={cor}
                  onChange={(e) => setCor(e.target.value)}
                />
              </div>
            </div>
          </div>

          <div className={styles.formSection}>
            <div className={styles.formSectionTitle}>Classificação</div>
            <div className={styles.formGrid3}>
              <div className={styles.formField}>
                <label htmlFor="prod-resina" className={styles.formLabel}>
                  Resina <span className={styles.obrigatorio}>*</span>
                </label>
                <select
                  id="prod-resina"
                  className={styles.formSelect}
                  value={resina}
                  onChange={(e) => setResina(e.target.value)}
                  disabled={carregandoOpcoes}
                >
                  <option value="">
                    {carregandoOpcoes ? 'Carregando...' : 'Selecione...'}
                  </option>
                  {resinasOpts.map((r) => (
                    <option key={r} value={r}>
                      {r}
                    </option>
                  ))}
                </select>
              </div>
              <div className={styles.formField}>
                <label htmlFor="prod-vpl" className={styles.formLabel}>
                  Valor médio por litro (R$)
                </label>
                <input
                  id="prod-vpl"
                  type="text"
                  inputMode="decimal"
                  className={styles.formInput}
                  placeholder="Ex: 45,00"
                  value={valorPorLitro}
                  onChange={(e) => setValorPorLitro(e.target.value)}
                />
              </div>
            </div>
            {!carregandoOpcoes && opcoes.resinas.length === 0 && (
              <div className={styles.formHint} style={{ marginTop: 8 }}>
                Nenhuma resina cadastrada ainda. Cadastre em Cadastros antes de classificar o produto.
              </div>
            )}
          </div>

          <div className={styles.formSection}>
            <div className={styles.formSectionTitle}>Orientação de uso</div>
            <div className={styles.formField}>
              <label htmlFor="prod-orientacao" className={styles.formLabel}>Instruções técnicas</label>
              <textarea
                id="prod-orientacao"
                className={styles.formTextarea}
                placeholder="Ex: Aplicar 2 demãos com intervalo mínimo de 6h..."
                value={orientacao}
                onChange={(e) => setOrientacao(e.target.value)}
              />
              <div className={styles.formHint}>
                Texto livre exibido no drawer do produto na tela de Estoque.
              </div>
            </div>
          </div>

          <div className={styles.formSection}>
            <div className={styles.formSectionTitle}>Status do produto</div>
            <div className={styles.toggleStatus}>
              <div
                className={`${styles.toggleSwitch} ${ativo ? styles.ativo : ''}`}
                onClick={() => setAtivo(!ativo)}
              />
              <div className={styles.toggleLabel}>
                Produto {ativo ? 'ativo' : 'inativo'}
                <small>
                  Produtos inativos não aparecem nas movimentações e ficam
                  ocultos por padrão.
                </small>
              </div>
            </div>
          </div>
        </div>

        <div className={styles.modalFoot}>
          <button className={styles.btnSecondary} onClick={onCancelar}>
            Cancelar
          </button>
          <button
            className={styles.btnPrimary}
            onClick={handleSalvar}
            disabled={!valido || salvando}
          >
            {salvando ? 'Salvando...' : editando ? 'Salvar alterações' : 'Cadastrar produto'}
          </button>
        </div>
      </div>
    </div>
  );
}

